var _desc, _defs, _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgVisainline(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 54,
    height: 33,
    viewBox: "0 0 54 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Accepted Visa") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "linearGradient-1",
    x1: "100%",
    x2: "0%",
    y1: "50%",
    y2: "50%"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#112B99"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#1A1E5D"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Checkout-Add-Payment",
    fill: "none",
    fillRule: "evenodd",
    stroke: "none",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("g", {
    id: "1.3-Detect-Card-Type-1",
    transform: "translate(-691.000000, -290.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "modal",
    transform: "translate(300.000000, 148.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Input-/-Text-Input-/-Idle-&-Empty-Copy-2",
    transform: "translate(391.000000, 115.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Accepted-Visa",
    transform: "translate(0.000000, 27.000000)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle",
    width: 52.731,
    height: 31.239,
    x: 0.5,
    y: 0.5,
    fill: "#FFF",
    stroke: "#E0E3E4",
    rx: 3
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(6.000000, 9.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Combined-Shape",
    fill: "url(#linearGradient-1)",
    d: "M16.5834756,0.643547763 L19.8352729,0.643547763 L17.8011327,13.2634579 L14.5491495,13.2634579 L16.5834756,0.643547763 Z M29.5964302,0.953300552 L29.1560129,3.68907744 L28.8640133,3.54482434 C28.2640191,3.28837438 27.4940328,3.04273408 26.430373,3.05988044 C25.1567338,3.05988044 24.5682708,3.62142386 24.5675269,4.14587894 C24.5595295,4.73817398 25.2569808,5.1258309 26.3933616,5.71104376 C28.2699707,6.61122785 29.1364843,7.70151294 29.1247671,9.13994377 C29.0987289,11.7586781 26.8786017,13.4505769 23.461834,13.4505769 C22.0029517,13.4345488 20.5972618,13.1294553 19.8389926,12.7779549 L20.2937309,9.95309143 L20.7120158,10.1540021 C21.7814412,10.6251543 22.4731269,10.8158145 23.7750362,10.8158145 C24.709993,10.8158145 25.712649,10.4285303 25.7213904,9.58332637 C25.7264121,9.03072888 25.3006878,8.63524428 24.0335581,8.01722968 C22.8006501,7.41431135 21.1652661,6.40267589 21.1857247,4.58870242 C21.2045094,2.13639965 23.4675996,0.423813383 26.6825714,0.423813383 C27.9422616,0.423813383 28.9534731,0.700018939 29.5964302,0.953300552 Z M37.9381345,0.656407535 L40.569851,13.2679308 L37.5516535,13.2679308 C37.5516535,13.2679308 37.2531443,11.8175721 37.1556871,11.3771715 C36.6819781,11.3771715 33.3632255,11.3706484 32.9906935,11.3706484 C32.8642223,11.7120847 32.3070052,13.2679308 32.3070052,13.2679308 L28.8915394,13.2679308 L33.7206926,1.7025221 C34.0621648,0.879683012 34.6456061,0.656407535 35.4250778,0.656407535 L37.9381345,0.656407535 Z M33.9263943,8.7891888 L36.625996,8.7891888 C36.497479,8.15831444 35.8734925,5.14614562 35.8734925,5.14614562 L35.6540278,4.05772426 C35.4898013,4.53074026 35.2028233,5.29505806 35.2217939,5.2616972 C35.2217939,5.2616972 34.1958895,8.06382306 33.9263943,8.7891888 Z M11.8210917,0.654171053 L15.2670594,0.654171053 L10.1460925,13.2504117 L6.70458853,13.2524618 L3.79277558,2.21542203 C5.85797557,3.30980733 7.70426882,5.49391861 8.29738146,7.5089891 L8.63829569,9.2579182 L11.8210917,0.654171053 Z"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Fill-7",
    fill: "#EC982D",
    d: "M5.68370572,0.645597871 L0.439801397,0.645597871 L0.396652406,0.907079919 C4.47702187,1.95244899 7.1768096,4.47576007 8.29738146,7.5089891 L7.15783893,1.71034979 C6.96125064,0.910621016 6.38989848,0.673553899 5.68370572,0.645597871"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisainline);
export default __webpack_public_path__ + "static/media/visa.inline.5354242f.svg";
export { ForwardRef as ReactComponent };